import React from 'react';
import { Box, Grid, Card } from '@applyboard/ui-components';
import CefDesktopPageWrapper from "../../CEF/Layout/CefDesktopPageWrapper";
import CloseButton from "../../CEF/Common/CloseButton/CloseButtonCore";
import BackButton from "../../CEF/Layout/BackButton";
import { useOnboardingFormControllerContext } from "../../controller/OnboardingFormController";
export var Layout = function Layout(_ref) {
  var children = _ref.children,
    _ref$noBackButton = _ref.noBackButton,
    noBackButton = _ref$noBackButton === void 0 ? false : _ref$noBackButton;
  var _useOnboardingFormCon = useOnboardingFormControllerContext(),
    handleExit = _useOnboardingFormCon.handleExit;
  return /*#__PURE__*/React.createElement(CefDesktopPageWrapper, null, /*#__PURE__*/React.createElement(Card, {
    mt: 11,
    size: "sm"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    mt: 3,
    mx: 4
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, !noBackButton && /*#__PURE__*/React.createElement(BackButton, null)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(CloseButton, {
    onClick: function onClick() {
      return handleExit();
    }
  })))), /*#__PURE__*/React.createElement(Box, {
    pt: 3,
    mx: -1,
    mb: -1
  }, children)));
};